import React, { Component } from "react";

export default class Overlay extends Component {
  closeRef = React.createRef();
  currentFocus = null;

  keyListener = (e) => {
    if (e.keyCode === 27) {
      this.props.close();
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.keyListener);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyListener);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.currentFocus = document.activeElement;
      this.closeRef.current.focus();
    }
  }

  render() {
    return (
      <div
        className={`z-20 overlay fixed pin-t pin-l w-full h-full justify-center items-center p-6 bg-black-85${
          this.props.show ? " flex" : " hidden"
        }`}
        role="dialog"
      >
        <div className="overlay-content bg-white rounded-sm max-w-md container px-6 pb-12 pt-20 relative max-h-full overflow-auto">
          <div
            className="overlay-inner"
            dangerouslySetInnerHTML={{ __html: this.props.children }}
          ></div>
          <button
            type="button"
            aria-label="Exit"
            tabIndex="0"
            ref={this.closeRef}
            className="num absolute pin-r pin-t mr-6 mt-6 cursor-pointer w-12 h-12 rounded-full border-2 border-grey-lighter text-red flex items-center justify-center md:bg-transparent bg-white"
            onClick={() => {
              this.props.close();
              this.currentFocus.focus();
            }}
          >
            X
          </button>
        </div>
      </div>
    );
  }
}
